export default __webpack_public_path__ + "static/media/campus.a3d87367.svg";